import { Component, OnDestroy, OnInit } from '@angular/core';
import { FreyaHelperService } from 'src/app/services/freya-helper.service';
import { SubSink } from 'subsink';

import { DashboardStore, groupLeadsByValues, pipelineMetrics, pipelinePeriods } from '../dashboardv2.store';

@Component({
  selector: 'app-dashboard-engine',
  standalone: false,
  templateUrl: './dashboard-engine.component.html',
  styleUrl: './dashboard-engine.component.scss',
})
export class DashboardEngineComponent implements OnInit, OnDestroy {

  layout$ = this.dashboardStore.sharedViewModel$;

  actionableItems$ = this.dashboardStore.actionableItems$;

  filterChips$ = this.dashboardStore.filterChips$;

  pipelineChartHeader$ = this.dashboardStore.pipelineChartHeader$;

  metrics = pipelineMetrics;

  periods = pipelinePeriods;

  groupLeadsBy = groupLeadsByValues;

  subs = new SubSink();

  threshold = 115;

  setMetric = this.dashboardStore.setPipelineMetric;

  setPeriod = this.dashboardStore.setPipelinePeriod;

  setGroupLeadsBy = this.dashboardStore.setGroupLeadsBy;

  constructor(
    private dashboardStore: DashboardStore,
    private freyaHelper: FreyaHelperService,
  ) {}

  ngOnInit(): void {
    this.subs.sink = this.freyaHelper.layoutScrolled.subscribe(({ position, height }) => {

      const isNearBottom = position > height - this.threshold;

      if (isNearBottom) {
        this.dashboardStore.notifyBottomReached('engine');
      }
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

}
